import { create } from 'zustand';

export type PartInfoResponse = {
  partNumber: string;
  partName: string;
  location: string;
  availability: string;
  retailPriceExlVat: number;
  discount: string;
};

type PartInfoCacheState = {
  cache: Map<string, PartInfoResponse>;
  needReload: boolean;
  mainIndex?: number;
  rowIndex?: number;
  setPartInfo: (key: string, info: PartInfoResponse) => void;
  getPartInfo: (key: string) => PartInfoResponse | undefined;
  clearCache: () => void;
  setNeedReload: (val: boolean, mainIndex?: number, rowIndex?: number) => void;
};

export const useAvailabilityCache = create<PartInfoCacheState>((set, get) => ({
  cache: new Map(),
  needReload: false,

  setPartInfo: (key, info) => {
    const updatedCache = new Map(get().cache);
    updatedCache.set(key, info);
    set({ cache: updatedCache });
  },

  getPartInfo: (key) => {
    return get().cache.get(key);
  },

  clearCache: () => {
    set({ cache: new Map() });
  },

  setNeedReload: (val, mainIndex, rowIndex) => {
    set({ needReload: val, mainIndex, rowIndex });
  }
}));
